
<template>
  <div>
    <tableComponents
      ref="tableComponents"
      :isHaveExport="false"
      @toAdd="dialogVisible = true"
      :isShow="false"
      :isHavePagination="false"
    >
      <template v-slot:table>
        <el-table :data="list" style="width: 100%" :border="true">
          <el-table-column prop="id" label="ID" width="50px" fixed>
          </el-table-column>
          <el-table-column prop="name" label="名称" align="center">
          </el-table-column>
          <el-table-column prop="key" align="center" label="KEY">
          </el-table-column>
          <el-table-column prop="remark" align="center" label="备注信息">
          </el-table-column>
          <el-table-column prop="value" align="center" label="检测值">
          </el-table-column>
          <el-table-column prop="username" align="center" label="操作">
            <template v-slot="scope">
              <el-button
                size="mini"
                icon="el-icon-delete"
                type="danger"
                @click="delRule(scope.row.id)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </tableComponents>
    <!-- 
    'key',
  'name',
  'label',
  'time',
  'type',
  'type_rules',
  'msg',
  'is_show',
  'remark', -->
    <el-dialog title="新增渠道" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="ruleForm" label-width="80px" size="mini">
        <el-form-item label="key">
          <el-input v-model="ruleForm.key"></el-input>
        </el-form-item>
        <el-form-item label="风控名称">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="label">
          <el-input v-model="ruleForm.label"></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="提示信息">
          <el-input v-model="ruleForm.msg"></el-input>
        </el-form-item> -->
        <el-form-item label="备注信息">
          <el-input v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="检测值">
          <el-input v-model="ruleForm.value"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {},
      list: [],
      appInfo: {
        id: "",
      },
    };
  },

  methods: {
    async onSubmit() {
      
      let data = await this.$api.getAppRules.postAddAppRules({
        ...this.ruleForm,
      });
      if (data.code == 200) {
        this.getAppRulesList();
      }
      this.dialogVisible = false;
    },
    delRule(id) {
      this.$swal({
        title: "您确定要删除这条信息吗",
        text: "删除后将无法恢复，请谨慎操作！",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async (willDelete) => {
        if (willDelete.value) {
          let data = await this.$api.getAppRules.postDelAppRules({ id });
          if (data.code == 200) {
            this.$fnc.success("删除成功");
            this.getAppRulesList();
          }
        }
      });
    },
    async addChannel() {
      let data = await this.$api.getChannel.postAddChannel(this.ruleForm);
      if (data.code == 200) {
        this.$message.success("添加成功");
        this.dialogVisible = false;
        this.getAppRulesList();
      }
    },

    async getAppRulesList() {
      let data = await this.$api.getAppRules.getAppRulesList();
      this.list = data.data;
    },
  },
  created() {
    this.getAppRulesList();
  },
  components: {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.user_user_info {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
  }
  .nickcname {
    background-color: #409eff;
    color: #fff;
    border-radius: 5px;
    width: max-content;
    padding: 0 5px;
    margin-top: 5px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
.fx {
  justify-content: center;
  margin-top: 3px;
  .text {
    width: 60px;
    min-width: max-content;
    flex: 1;
    text-align: left;
  }
}
.apk_url {
  width: 70px;
  overflow: hidden;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .el-table .el-table__cell {
  padding: 5px 0;
}
</style>